import { createPinia } from 'pinia';

const pinia = createPinia()

export * from './design';
export * from './preview';

export default pinia;